import {
  GapEnum,
  Stack,
} from '@delmonicos/shared-design-system-react/src/components/stack/stack';
import { Tabs } from '@delmonicos/shared-design-system-react/src/components/tab/tabs.component';
import {
  extractTabKeys,
  useTabQuery,
} from '@delmonicos/shared-sdk/libs/cpms/src/clients/utils/hooks';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import { EmspBoInvoiceEmspUserDetailsController } from '../emsp-bo-invoice-emsp-user-details/emsp-bo-invoice-emsp-user-details.controller';
import { EmspBoInvoiceTotalsDetailsController } from '../emsp-bo-invoice-totals-details/emsp-bo-invoice-totals-details.controller';
import { EmspBoInvoiceDetailsInformationCard } from './cards/information.card';

enum TabsEnum {
  INFORMATION = 'information-tab',
}

export const EmspBoInvoiceDetailsView = (): React.JSX.Element => {
  // CONTEXT ///////////////////////////////////////////////////////////////////

  const { t } = useTranslation();

  // USER PERMISSIONS //////////////////////////////////////////////////////////

  // Nothing to do

  // ACTIONS ///////////////////////////////////////////////////////////////////

  // Nothing to do

  // TABS //////////////////////////////////////////////////////////////////////

  const tabs = useMemo(
    () =>
      [
        {
          title: t('$.emsp-bo-invoice-details.information.title'),
          icon: 'file-05',
          key: TabsEnum.INFORMATION,
        },
      ] as const,
    [t],
  );

  const { tab } = useTabQuery(TabsEnum.INFORMATION, extractTabKeys(tabs));

  const renderTab = () => {
    switch (tab) {
      case TabsEnum.INFORMATION:
        return (
          <Stack flex={1} gap={GapEnum.M}>
            <EmspBoInvoiceDetailsInformationCard />
            <Stack flex={1} gap={GapEnum.M} direction="column">
              <EmspBoInvoiceEmspUserDetailsController />
              <EmspBoInvoiceTotalsDetailsController />
            </Stack>
          </Stack>
        );
      default:
        return null;
    }
  };

  // RENDER ////////////////////////////////////////////////////////////////////

  return (
    <Stack flex={1} direction="column" gap={GapEnum.XL}>
      {tabs.length > 1 && (
        <Tabs currentTab={tab} elements={tabs} onTabClick={() => {}} />
      )}
      {renderTab()}
    </Stack>
  );
};
